/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointIcon24Solid = forwardRef('HandPointIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 13V4a2 2 0 1 1 4 0v5l5.59.735a3.5 3.5 0 0 1 2.934 4.336l-1.448 5.671A3 3 0 0 1 16.17 22h-5.26a3 3 0 0 1-2.018-.78l-5.55-5.045a2.564 2.564 0 0 1 2.998-4.123L8 13Z" })));
});
